import { makeVar } from "@/hooks/useVar.tsx";

export const showSettingsVar = makeVar<boolean>(false);
